module.exports = __webpack_public_path__ + "media/images/av-logo-horizontal-black-ff33d214660e64b477b75d6f6f9153c6.png";